import { axiosClient, buildQuery } from '@nx-frontend/shared/api';
import { BucketFile } from '@nx-frontend/shared/types';

export interface ClientGetWorkspaceFilesParams {
  workspaceId: string;
  portalId: string | undefined;
  showPortalFiles: boolean;
  limitSize?: number;
  limitFrom?: number;
}

export async function clientGetWorkspaceFiles(params: ClientGetWorkspaceFilesParams): Promise<BucketFile[] | null> {
  const { workspaceId, portalId, showPortalFiles, limitFrom, limitSize } = params;
  const query = buildQuery({
    portalId,
    showPortalFiles,
    limitSize,
    limitFrom,
    resetCache: 'true',
  });
  const q = query ? `?${query}` : '';

  if (!workspaceId) return null;
  try {
    const response = await axiosClient.get<BucketFile[]>(`/v2/api/workspaces/${workspaceId}/files${q}`);
    return response.data;
  } catch (err) {
    console.log(`clientGetWorkspaceFiles error: ${err}`);
  }
  return null;
}
